import type { UserRole } from "@/types/api";

/** 旧版前台 (经典版)。在 SPA basename /admin 之外, 只能整页跳转, 不能用 router navigate */
export const LEGACY_HOME = "/static/";

/** 登录后默认落点 (SPA 内): 管理员进仪表盘, 其他人进前台报价 */
export function homePathFor(role: UserRole): string {
  return role === "super_admin" || role === "company_admin" ? "/dashboard" : "/";
}

/** 普通用户默认用旧版页面 (/static/); 管理员留在 React 管理后台 */
export function prefersLegacyHome(role: UserRole | undefined | null): boolean {
  return role === "user";
}

/**
 * 登录 / 注册成功后的去向 (SPA 内路径) —— 返回 null 表示应整页跳到旧版 LEGACY_HOME。
 * from: 被 ProtectedRoute 拦下前想去的 SPA 页面 (深链), 有就优先回去; "/" 不算深链。
 */
export function postLoginTarget(role: UserRole, from?: string | null): string | null {
  if (from && from !== "/" && from !== "/login" && from !== "/register") return from;
  return prefersLegacyHome(role) ? null : homePathFor(role);
}

let leaving = false;
// 从 bfcache 恢复 (跳走后按浏览器后退) 时页面状态被原样还原, 要允许再次跳转
if (typeof window !== "undefined") {
  window.addEventListener?.("pageshow", (e) => {
    if (e.persisted) leaving = false;
  });
}

/**
 * 整页跳到旧版前台。replace=true 时不留历史记录 (自动跳转用, 避免后退又被弹回来)。
 * 登录成功时 handleResult 与随后的重渲染 (已登录 → 重定向) 都会调用, 只跳一次。
 */
export function goLegacyHome(replace = false): void {
  if (typeof window === "undefined" || leaving) return;
  leaving = true;
  if (replace) window.location.replace(LEGACY_HOME);
  else window.location.assign(LEGACY_HOME);
}
